import React from "react";
import {
  Container,
  Row,
  Col,
  Button,
  Image,
  CardBody,
  Card,
} from "react-bootstrap";
import { LuArrowUpRight } from "react-icons/lu";
import {
  primaryColor,
  secondaryColor,
  textDarkColor,
} from "../Constants/Colors";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import { GrLinkNext, GrLinkPrevious } from "react-icons/gr";
import { Link } from "react-router-dom";
import FAQ from "../Pages/Website/LandingPage/FAQSection/FAQ";
import GetInTouch from "./GetInTouch";
import { FaCheck } from "react-icons/fa";

const ServiceComponent = ({ data }) => {
  const service = data || {};

  return (
    <>
      <Container className="mt-2 mb-5">
        <div className="text-center mb-4">
          {service.service_title && (
            <>
              <Button
                variant="primary"
                className="mb-3"
                style={{ borderRadius: "30px" }}
              >
                {service.service_title}
              </Button>

              <Row>
                <Col xs={12} md={8} className="mx-auto">
                  <h1 className="fw-bold" style={{ color: primaryColor }}>
                    {service.service_subtitle}
                  </h1>
                </Col>
              </Row>

              <p className="fw-semibold text-muted">
                {service.service_description || ""}
              </p>
            </>
          )}

          {service.button_text_1 && service.button_link_1 && (
            <Link
              to={service.button_link_1}
              style={{
                backgroundColor: secondaryColor,
                color: textDarkColor,
                border: "none",
              }}
              className="rounded-pill my-2 px-4 arrowLauncher-container btn"
            >
              {service.button_text_1}{" "}
              <LuArrowUpRight className="fs-5 arrowLauncher" />
            </Link>
          )}
          {service.button_text_2 && service.button_link_2 && (
            <Link
              to={service.button_link_2}
              style={{
                backgroundColor: "transparent",
                color: textDarkColor,
                border: "2px solid #d1e231",
              }}
              className="rounded-pill px-2 ms-2 custom-outline-button arrowLauncher-container btn"
            >
              {service.button_text_2}{" "}
              <LuArrowUpRight className="fs-5 arrowLauncher" />
            </Link>
          )}
        </div>

        <Row className="d-flex align-items-center my-5 mx-auto gap-0 gap-lg-5 justify-content-center">
          {service.why_this_service_title && (
            <Col md={9} lg={8}>
              <h3 className="fw-bold mb-3" style={{ color: primaryColor }}>
                {service.why_this_service_title}
              </h3>
              <p className="text-muted">
                {service.why_this_service_description}
              </p>
              <h5 className="fw-bold">{service.why_this_service_subtitle}</h5>
              <ul className="list-unstyled">
                {service.benefits?.map((benefit, index) => (
                  <li key={index} className="mb-2 d-flex align-items-center">
                    {benefit.benefit_icon ? (
                      <Image
                        src={benefit.benefit_icon}
                        style={{ width: "15px", height: "15px" }}
                        className="me-2"
                      />
                    ) : (
                      <FaCheck className="text-primary me-2" />
                    )}
                    {benefit.benefit_text}
                  </li>
                ))}
              </ul>
              {service.why_this_service_highlightText && (
                <div
                  style={{ backgroundColor: "#D8F1FF" }}
                  className="mt-3 p-2 "
                >
                  <p className="text-muted mb-0 fw-semibold">
                    {service.why_this_service_highlightText}
                  </p>
                </div>
              )}
            </Col>
          )}

          {service.headerImage && (
            <Col xs={7} md={3} className="text-center p-0">
              <Image
                src={service.headerImage}
                alt="Header"
                className="rounded"
                fluid
              />
            </Col>
          )}
        </Row>

        {/* Development Process Slider */}
        {service.process?.length > 0 && (
          <>
            <Row>
              <Col md={10}>
                <h3 className="fw-bold mb-3">
                  <span style={{ color: primaryColor }}>
                    {service.dev_process_title}
                  </span>
                </h3>
                <p className="text-muted fw-bold">
                  {service.dev_process_subtitle}
                </p>
                <p className="text-muted">{service.dev_process_description}</p>
              </Col>
            </Row>
            <div className="px-0 px-md-3">
              <Swiper
                modules={[Autoplay, Navigation, Pagination]}
                autoplay={{ delay: 3000, disableOnInteraction: false }}
                loop={service.process.length > 1}
                slidesPerView={"auto"}
                spaceBetween={20}
                pagination={{ clickable: true, el: ".custom-pagination" }}
                navigation={{ nextEl: ".custom-next", prevEl: ".custom-prev" }}
                breakpoints={{
                  0: { slidesPerView: 1 },
                  768: { slidesPerView: 2 },
                }}
                className="mySwiper py-1"
              >
                {service.process.map((process, index) => {
                  const descriptionList = [
                    process.process_description_one,
                    process.process_description_two,
                    process.process_description_three,
                    process.process_description_four,
                    process.process_description_five,
                  ].filter(Boolean);

                  return (
                    <SwiperSlide key={index} style={{ maxWidth: "700px" }}>
                      <div
                        style={{
                          padding: "2px",
                          borderRadius: "20px",
                          background: `linear-gradient(to right, ${secondaryColor}, ${primaryColor})`,
                        }}
                      >
                        <Card
                          style={{
                            color: textDarkColor,
                            cursor: "pointer",
                            borderRadius: "18px",
                            border:"none"
                          }}
                          className="overflow-hidden"
                        >
                          <CardBody>
                            <Row className="align-items-center d-flex">
                              <Col xs={12}>
                                <h4 style={{ color: primaryColor }}>
                                  {process.process_title}
                                </h4>
                                <p className="mb-0 fw-semibold text-muted">
                                  {process.process_subtitle}
                                </p>
                                <ul className="mt-2">
                                  {descriptionList.map((desc, idx) => (
                                    <li className="text-muted" key={idx}>
                                      {desc}
                                    </li>
                                  ))}
                                </ul>
                              </Col>
                            </Row>
                          </CardBody>
                        </Card>
                      </div>
                    </SwiperSlide>
                  );
                })}
              </Swiper>
              <div className="d-flex flex-row justify-content-center align-items-center mt-3 gap-3">
                <div className="custom-prev px-2 px-md-3">
                  <GrLinkPrevious />
                </div>
                <div className="custom-pagination d-flex gap-2 w-auto mt-1 mt-md-2" />
                <div className="custom-next px-2 px-md-3">
                  <GrLinkNext />
                </div>
              </div>
            </div>
          </>
        )}

        {/* Deliverables */}
        {service.deliverables?.length > 0 && (
          <Row
            className="align-items-start flex-column flex-md-row py-5 my-5"
            style={{ backgroundColor: " #C8E6F5" }}
          >
            <Col
              md={4}
              className="justify-content-center align-items-center d-flex my-auto"
            >
              <div className="text-center text-md-start">
                <h1 style={{ color: primaryColor }}>Our Key</h1>
                <h1>Deliverables</h1>
              </div>
            </Col>
            <Col md={8}>
              <div className="scrollbox">
                {service.deliverables.map((item, index) => (
                  <div key={index} className="mb-5">
                    <h5
                      className="fw-light mb-2"
                      style={{ fontSize: "1.25rem", color: primaryColor }}
                    >
                      {index + 1}
                    </h5>
                    <h3
                      className="fw-bold text-dark mb-2"
                      style={{ fontSize: "1.5rem" }}
                    >
                      {item.deliverables_title}
                    </h3>
                    <p className="text-muted text-justify">
                      {item.deliverables_description}
                    </p>
                  </div>
                ))}
              </div>
            </Col>
          </Row>
        )}

        {/* Why Choose Us */}
        {service.whyChoose?.length > 0 && (
          <>
            <h2
              className="fw-bold text-start mb-5"
              style={{ color: primaryColor }}
            >
              {service.why_choose_title || "Why Choose Us"}
            </h2>
            {service.whyChoose.map((item, index) => (
              <Row
                className={`align-items-center justify-content-center mb-4 ${
                  index % 2 !== 0 ? "flex-md-row-reverse" : ""
                }`}
                key={index}
              >
                <Col md={6} className="mb-4 mb-md-0">
                  <h5 className="fw-bold" style={{ color: primaryColor }}>
                    {item.why_choose_title}
                  </h5>
                  <p className="text-muted text-justify">
                    {item.why_choose_description}
                  </p>
                </Col>
                <Col xs={7} md={4} className="text-center">
                  {item.why_choose_image && (
                    <Image
                      src={item.why_choose_image}
                      alt={item.why_choose_title}
                      fluid
                      style={{ objectFit: "contain", maxHeight: "250px" }}
                    />
                  )}
                </Col>
              </Row>
            ))}
          </>
        )}

        {/* Tech Stack */}
        {service.techstack_title && (
          <div className="mt-5 text-center">
            <h4 className="fw-bold mb-3" style={{ color: primaryColor }}>
              {service.techstack_title}
            </h4>
            <p className="text-muted mx-auto" style={{ maxWidth: "800px" }}>
              {service.techstack_description}
            </p>
          </div>
        )}

        {/* Tools */}
        {/* Tools */}
        {(service.tools_title || service.tools?.length > 0) && (
          <div className="mt-4 text-center">
            {service.tools_title && (
              <h5 className="fw-bold mb-4" style={{ color: primaryColor }}>
                {service.tools_title}
              </h5>
            )}
            {service.tools?.length > 0 && (
              <Row className="justify-content-center g-4">
                {service.tools.map((tool, index) => (
                  <Col xs={6} sm={4} md={3} lg={2} key={index}>
                    <div
                      className="d-flex align-items-center justify-content-center h-100"
                      style={{
                        minHeight: "100px",
                        transition: "transform 0.3s ease",
                      }}
                      onMouseEnter={(e) =>
                        (e.currentTarget.style.transform = "translateY(-3px)")
                      }
                      onMouseLeave={(e) =>
                        (e.currentTarget.style.transform = "translateY(0)")
                      }
                    >
                      {tool.tool_image && (
                        <Image
                          src={tool.tool_image}
                          alt={`Tool ${index + 1}`}
                          fluid
                          style={{
                            maxWidth: "80px",
                            maxHeight: "80px",
                            objectFit: "contain",
                          }}
                        />
                      )}
                    </div>
                  </Col>
                ))}
              </Row>
            )}
          </div>
        )}
      </Container>

      {/* FAQ Section */}
      {service.faqs?.length > 0 && (
        <FAQ
          data={service.faqs.map((f) => ({
            question: f.faq_question,
            answer: f.faq_answer,
          }))}
          heading="What Clients Usually Ask Us"
          description="Have questions? We've got answers. Explore some of the most common queries."
          showContactCTA={true}
          contactLink="/contactUs"
        />
      )}

      {/* CTA Section */}
      {service.cta_title && service.cta_description && (
        <GetInTouch
          radius={60}
          title={service.cta_title}
          description={service.cta_description}
          bgColor="light"
          borderColor={secondaryColor}
          textColor={textDarkColor}
          subTextColor={primaryColor}
          circleTextColor={textDarkColor}
          descriptionColor={textDarkColor}
        />
      )}
    </>
  );
};

export default ServiceComponent;
